import { Switch } from '@/components/ui/switch'
import { Typography } from '@/components/ui/typography'
import { cn } from '@/lib/utils'
import { useId } from 'react'

const visibilityCopy = {
  menu: {
    ariaSuffix: 'in menu',
  },
  website: {
    ariaSuffix: 'on website',
  },
}

export default function NavigationVisibilityControl({
  checked,
  disabled = false,
  itemLabel,
  onCheckedChange,
  scope = 'menu',
  className,
}) {
  const controlId = useId()
  const copy = visibilityCopy[scope] ?? visibilityCopy.menu
  const stateLabel = checked ? 'Shown' : 'Hidden'

  return (
    <label
      htmlFor={controlId}
      className={cn(
        'inline-flex min-h-8 shrink-0 items-center gap-2',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className
      )}
    >
      <Typography variant="caption" weight="medium" className="whitespace-nowrap">
        {stateLabel}
      </Typography>
      <Switch
        id={controlId}
        checked={checked}
        disabled={disabled}
        aria-label={`Show ${itemLabel} ${copy.ariaSuffix}`}
        onCheckedChange={onCheckedChange}
      />
    </label>
  )
}
